// 一時保存フラグ
export const TEMP_SAVE_FLAG = {
    OFF: 0,
    ON: 1,
};

// 機器編集部分
export type DeviceInputList = {
    input_row_number?: number;
    prefecture_id?: number;
    city_id?: number;
    unit_count?: number;
    freeword?: string;
};

// 機器リスト 5001res/5002req共用
export type DeviceList = {
    device_row_number: number;
    estq_id?: number;
    maker_name?: string;
    mp_product_name?: string;
    searchword?: string;
    model_number?: string;
    input_list: Array<DeviceInputList>;
};

// 見積り依頼編集部分
export type EstimateEditList = {
    device_row_number: number;
    input_row_number: number;
    mainte_start_year: string;
    mainte_start_month: string;
    mainte_end_year: string;
    mainte_end_month: string;
    sla_id: string;
    check_flag: number;
};

// 見積り依頼リスト 5001res/5002req共用
export type EstimateList = {
    pattern_name: string;
    estimate_list: Array<EstimateEditList>;
};

// API-5001 GET /api/estimate/get/{id} response
export type GetEstimateResponse = {
    status: boolean;
    device_list: Array<DeviceList>;
    estimate_pattern_list: Array<EstimateList>;
};

// API-5002 POST /api/estimate/save request
export type SaveEstimateApiRequest = {
    temp_save_flag: number;
    device_list: Array<DeviceList>;
    estimate_pattern_list: Array<EstimateList>;
};

// API-5002 POST /api/estimate/save response
export type SaveEstimateApiResponse = {
    status: boolean;
    inquiry_estimate_id: string;
};

// API-5003 POST /api/estimate/mail request
export type SaveEstimateMailApiRequest = {
    draft_path: string;
    inquiry_estimate_id: string;
    mail: string;
};

// API-5003 POST /api/estimate/mail response
export type SaveEstimateMailApiResponse = {
    status: boolean;
};

// API ERROR
export const ESTIMATE_API_ERRORS = {
    REQUEST_ERROR_5001: 'REQUEST_ERROR(5001)',
    REQUEST_ERROR_5001_STATUS_CODE: 'REQUEST_ERROR(5001)_%1',
    REQUEST_ERROR_5002: 'REQUEST_ERROR(5002)',
    REQUEST_ERROR_5002_STATUS_CODE: 'REQUEST_ERROR(5002)_%1',
    REQUEST_ERROR_5003: 'REQUEST_ERROR(5003)',
    REQUEST_ERROR_5003_STATUS_CODE: 'REQUEST_ERROR(5003)_%1',
};
